export default "__VITE_ASSET__CgcEdTnR__"